import { configureStore } from "@reduxjs/toolkit";
import invoiceSliceDetails from "../apis/invoiceSlice";
import authSliceDetails from "src/apis/authSlice";
import entitySliceDetails from "src/apis/entitySlice";
import itemSliceDetails from "src/apis/itemSlice";

export const store = configureStore({
  reducer: {
    invoiceData: invoiceSliceDetails,
    authData: authSliceDetails,
    entData: entitySliceDetails,
    itemData: itemSliceDetails,
  },
});
